var products = [];

function Product(id,name,price,orders,body_html,img_src) {
    this.id = id;
    this.name = name;
    this.price = parseFloat(price);
    this.orders = parseInt(orders); 
    this.body_html = body_html;
    this.img_src = img_src;
}

Product.prototype.generateStr = function(ribbon){
    var str = '<div class="ca-item '+this.id+'">'+ribbon+'<div class="ca-item-main"><div class="ca-icon" style="background-image:url('+this.img_src+');background-size: 100% 100%"></div><h5>' + this.name + '</h5><div id="price"><h2> $'+ this.price +'</h2></div></div></div>'+"\n";

    return str;
}

Product.prototype.gridGenStr = function(mult,ribbon){
    var str = '<div class="ca-item '+this.id+'" style="position: absolute; left:'+ 294*mult +'px;">'+ribbon+'<div class="ca-item-main"><div class="ca-icon" style="background-image:url('+this.img_src+');background-size: 100% 100%"></div><h5>' + this.name + '</h5><div id="price"><h2>$'+ this.price +'</h2></div></div></div>'+"\n";
    
    return str;
}

function dynamicSort(property,direction) {

    var operators = {
	'lessthan': function(a, b) { return a < b },
	'greaterthan': function(a, b) { return a > b },
    };

    var op='';
    
    if (direction==="ascend"){
	op1='lessthan';
	op2='greaterthan';
    }
    else if (direction==="descend"){
	op1='greaterthan';
	op2='lessthan';
    }
    else
	return;

    return function (a,b) {
	return operators[op1](a[property],b[property]) ? -1 : operators[op2](a[property],b[property]) ? 1 : 0;
    }
}

function checkZeroArray(tmpArr,field){
    for(i=1;i<products.length;i++){
	if (tmpArr[i][field] != tmpArr[i-1][field])
	    return tmpArr[0][field];
    }
    return null;
}

function getPopular(products){
    var tmpArr = [];
    var cheapProduct =null;
    var popularProduct=null;
    tmpArr.length=0;
    
    tmpArr = products.slice(0);

    tmpArr.sort(dynamicSort("price","ascend"));
    cheapProduct = checkZeroArray(tmpArr,"price");

    tmpArr.sort(dynamicSort("orders","descend"));
    popularProduct = checkZeroArray(tmpArr,"orders");
    
    return [popularProduct, cheapProduct];
}


function sortAndCompute(products){

    var i=0;
    var sortBy="";
    var resultArr = [];
    var direction = "descend";
    resultArr.length=0;

    if (products.length<=1){
	return;
    }
    else {                                            // products.length > 1
	sortBy=$("#selectable .ui-selected").text().toLowerCase();

	if (sortBy==="popularity"){
	    sortBy="orders";
	    direction = "ascend";
	}

	resultArr = getPopular(products);
		
	if (sortBy!="none"){
	    products.sort(dynamicSort(sortBy,direction));
	}
	
    }

    return;
}

function renderCarousel(products){

    var output="";
    var popular=null;
    var popular_div="";

    if (products.length===0){
	output="";
    }
    else if (products.length===1){
	output=products[0].generateStr("");
    }
    else{

	popular=getPopular(products)[0];

	for(i=products.length-1;i>=0;i--){

	    if ((popular) && (products[i].orders==popular)){
		popular_div='<div class="ribbon"><a href="#">Popular!</a></div>';
	    }else{
		popular_div="";
	    }
	    output+=products[i].generateStr(popular_div);
	}
    }

    if ($('.ca-wrapper').length===0){

	// if (products.length>3)
	//     $(".ca-container").append('<div class="ca-nav"><span class="ca-nav-prev">Previous</span><span class="ca-nav-next">Next</span></div>');

	$(".ca-container").append('<div class="ca-wrapper" style="overflow: hidden;"></div>');

    }


    $('.ca-wrapper').empty();	      
    $(".ca-wrapper").append(output);
    $('#ca-container').contentcarousel();
}

function setContainerHeight(rows){

    //if nothing in grid dont adjust height of container 
    if (rows===0)
	return;

    var height=100+rows*350;

    $("#appContainer").parent().css('height', height+"px");
}


function genGrid(products){

    var i=0;
    var j=0;
    var k=products.length-1;
    var output = "";
    var tmpstr = "";
    var rows = Math.ceil(products.length/3);
    var rem = products.length % 3;
    var cols=3;
    var popular=null;
    var popular_div="";

    $('#ca-container').empty();

    setContainerHeight(rows);

    popular=getPopular(products)[0];
    
    for (i=0;i<rows;i++){

	if ((i==rows-1) && (rem != 0)){
	    cols=rem;
	}
	
	output='<div class="ca-wrapper">'+"\n";
	
	for (j=0;j<cols;j++){

	    if ((popular) && (products[k].orders==popular))
		popular_div='<div class="ribbon"><a href="#">Popular!</a></div>';
	    else
		popular_div="";

	    tmpstr= products[k].gridGenStr(j,popular_div);	    
	    output+= tmpstr;
	    k--;
	}
	
	output+='</div>';

	$('#ca-container').append(output);

    }
    
}

//check if user is viewing products using grid or list
function getView(){
    
    //for firefox
    view = $("#selectable2 .ui-selected").text()
    
    return view;
}


function loadApp(){

    var urlArr = window.location.href.split('/');
    

    var autoCompleteUrl = "/"+urlArr.slice(urlArr.length - 2,urlArr.length).join("/") + "/autocomplete_product";
    

    if ($('div#col-widgets').length != 0)
	$('div#col-widgets').remove();

    $("#demo-input").tokenInput(autoCompleteUrl, {
	
	propertyToSearch: "name",
	preventDuplicates: true,
        resultsFormatter: function(item){
	    
	    if (item){
		item.name = item.title + " ("+item.variant+")";
		item.id = item.variant_id;
	    }

	    return "<li>" + "<img src='" + item.img_src + "' title='" + item.title + "' height='25px' width='25px' />" + "<div style='display: inline-block; padding-left: 10px;'><div class='name'>" + item.name + "</div></div></li>" },

        onAdd: function (item) {
	    var product = new Product('ca-item-'+item.id,  item.name, item.price, item.orders,item.body_html,item.img_src);
	    
	    products.push(product);

	    sortAndCompute(products);

	    if (getView()==="List View")
		renderCarousel(products);
	    else
		genGrid(products);

	    $('.token-input-token').hide();
	    
        }
	
	// onDelete: function (item) {
	//     console.log("deletion 101");
	//     console.log(products);
	//     console.log("item.id " + item.id);

	//     var val = "ca-item-" +item.id;
	    
	//     for (var i = 0; i < products.length; i++) {
	// 	var c = products[i];
	// 	if (c.id == val || (val.equals && val.equals(c))) {
	// 	    console.log("c "+c+ "val "+val)
	// 	    products.splice(i, 1);
	// 	    break;
	// 	}
	//     }

	//     console.log("bongo " + products);
	    
	//     sortAndCompute(products);

	//     if (view==="List View")
	// 	renderCarousel(products);
	//     else
	// 	genGrid(products);
        // }
	
    });
    
    $(function() {
	$( "#selectable" ).selectable({
	    selected: function(event, ui)
	    {
		var view=null;

		//for firefox
		view = $("#selectable2 .ui-selected").text()


		if (view!="None"){
		    $('#ca-container').empty();
		    sortAndCompute(products);
		    if (view==="List View"){
			renderCarousel(products);
		    }else
			genGrid(products);
		}
	    }
	});
    });

}


$("selectable li").click(function() {
    $(this).addClass("selected").siblings().removeClass("selected");
});



$(function() {
    $( "#selectable2" ).selectable({
	selected: function(event, ui)
	{
	    var view=null;

	    //for firefox
	    view = $("#selectable2 .ui-selected").text()

	    switch(view)
	    {
	    case "List View":
		view="List View";
		$('#ca-container').empty();
		setContainerHeight(1);
		renderCarousel(products);
		break;
	    case "Grid View":
		view="Grid View";
		genGrid(products);
		break;
	    default:
		break;
	    }			
	}
    });
});

$("selectable2 li").click(function() {
    $(this).addClass("selected").siblings().removeClass("selected");
});
